import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Guid } from 'guid-typescript';
import { Observable } from 'rxjs';
import { TokenStorage } from '../core/token-storage';
import { Credential } from '../models/credential';
import { Token } from '../models/token';
import { UsersService } from './users.service';
import { ServiceBase } from './service-base';

@Injectable({
    providedIn: 'root',
})
export class AuthenticationService extends ServiceBase {
    constructor(private http: HttpClient, private userService: UsersService, private tokenStorage: TokenStorage) {
        super();
    }

    login(account: string, password: string): Observable<Token> {
        const credential = new Credential(account, password);

        // Ajoute un Identifiant de session
        sessionStorage.setItem('SessionId', Guid.create().toString());

        const httpOptions = {
            headers: new HttpHeaders().set('Content-Type', 'application/json'),
        };

        return this.http.post<Token>(`${this.baseUrl}/api/token`, credential, httpOptions);
    }

    logout(account: string) {
        const params = new HttpParams().set('account', account);

        this.http.delete(`${this.baseUrl}/api/token`, { params: params }).subscribe();

        this.userService.removeCurrentUser();

        // Supprime le token
        this.tokenStorage.signOut();
    }

    setCurrentToken(token: Token) {
        this.tokenStorage.saveToken(token.accessToken);
    }
}
